import React, { Component } from "react";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getItemNews } from '../../actions/newsActions';

class NewsItem extends Component {

    componentWillMount() {
        let id = this.props.match.params.id;
        this.props.getItemNews(id);
    }


    createMarkup(text) {
        return { __html: text };
    }

    render() {
        const { title, content } = this.props.news.data;
        return (
            <div className="menu-content-сontacts menu-content-item tab-parent screen-bottom-block">
                <div className="rounded-white-block">
                    <div>
                        <div className="white-block-top">
                            <h3>{title}</h3>
                        </div>
                        <div className="сontacts-info">
                            <div dangerouslySetInnerHTML={this.createMarkup(content)} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps, { getItemNews })(NewsItem);


// WEBPACK FOOTER //
// ./src/components/News/NewsItem.js